import { sanitize } from "../../../../common-deprecated/utils/sanitizer";
import type {
    AceBusinessLeasingConfigType,
    BusinessLeasingCTAConfigType,
    BusinessLeasingConfigType,
} from "../../ace/types";
import { parseAceCtaItem } from "./formatAceCta";

export const parseAceCarconfigCtaConfig = (
    aceConfig?: AceBusinessLeasingConfigType,
): BusinessLeasingCTAConfigType | null => {
    if (!aceConfig || !aceConfig?.businessLeasingCta) return null;

    return {
        default: aceConfig.businessLeasingCta?.default?.map(parseAceCtaItem) || [],
        mobile: aceConfig.businessLeasingCta?.mobile?.map(parseAceCtaItem) || [],
    };
};

export const parseAceCarConfigBusinessLeasingInfo = (
    aceConfig?: AceBusinessLeasingConfigType,
): BusinessLeasingConfigType | null => {
    if (!aceConfig?.businessLeasingInfo) return null;
    const {
        url,
        urlLabel,
        target,
        businessLeasingList: listItems,
        description,
        disclaimer,
        title,
    } = aceConfig.businessLeasingInfo;

    return {
        title,
        description: description ? sanitize(description) : undefined,
        disclaimer: disclaimer ? sanitize(disclaimer) : undefined,
        listItems: listItems || [],
        infoLink: { url: url || "", urlLabel: urlLabel || "", target: target || "_blank" },
        ctas: null,
    };
};
